import React, { BaseSyntheticEvent } from 'react'
import { ModalForm } from '../../../shared/ui/ModalForm/ModalForm'
import { modalActions } from '../../../entities/Modal'
import { SubmitHandler, useForm } from 'react-hook-form'
import { newApplicationActions } from '../model/slices/newApplicationSlice'
import { useNavigate } from 'react-router-dom'
import { addNewApplication } from '../model/services/addNewApplication'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectNewApp } from '../model/selectors/selectNewApp'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { AppExpirationDate } from './AppExpirationDate'
import { AppNameInput } from './AppNameInput'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { AppRightSelect } from './AppRightSelect'

const inputStyles = {
	width: '19rem'
}
const styles = {
	width: 700,
	p: '2rem'
}

export const AddNewAppModal = () => {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const {
		formState: { errors, isValid },
		handleSubmit,
		register,
		control,
		reset
	} = useForm({ mode: 'onBlur' })

	const newApp = useAppSelector(selectNewApp)
	const isFormValid = isValid && newApp.expirationDate

	const handleCancel = () => {
		dispatch(modalActions.hideModal())
		reset?.()
		dispatch(newApplicationActions.resetNewApp())
	}

	const onSubmit: SubmitHandler<{}> = async (_, event) => {
		event?.preventDefault()
		const result = await dispatch(addNewApplication())

		if (result.meta.requestStatus === 'fulfilled') {
			handleCancel()

			const appSecretKeyData = result.payload
			setTimeout(() => {
				dispatch(modalActions.hideModal())
				// @ts-ignore
				navigate(`/applications/${appSecretKeyData.applicationId}/secret`)
			})
		}
	}

	return (
		<ModalForm
			handleCancel={handleCancel}
			disabled={!isFormValid}
			handleOnSubmit={(e: BaseSyntheticEvent) =>
				handleSubmit(onSubmit({}, e))
			}
			modalTitle={'Add new application'}
			styles={styles}
		>
			<hr />
			<Typography
				variant="h6"
				sx={{ mb: '1.5rem' }}
			>
				General
			</Typography>
			<Stack direction="row" gap={4}>
				<AppNameInput
					register={register}
					validationErrors={errors}
					styles={inputStyles}
				/>
				<AppExpirationDate
					control={control}
					styles={inputStyles}
				/>
			</Stack>
			<Typography
				variant="h6"
				sx={{ my: '1.5rem' }}
			>
				Application permissions
			</Typography>
			<Stack direction="row" gap={4} sx={{ mb: '1.5rem' }}>
				<AppRightSelect
					label={'Clients'}
					labelId={'clients'}
					actionKey={'setClientsRights'}
					styles={inputStyles}
				/>
				<AppRightSelect
					label={'Products'}
					labelId={'products'}
					actionKey={'setProductsRights'}
					styles={inputStyles}
				/>
			</Stack>
			<Stack direction="row" gap={4} sx={{ mb: '1.5rem' }}>
				<AppRightSelect
					label={'Licenses'}
					labelId={'licenses'}
					actionKey={'setLicensesRights'}
					styles={inputStyles}
				/>
				<AppRightSelect
					label={'Instances'}
					labelId={'instances'}
					actionKey={'setInstancesRights'}
					styles={inputStyles}
				/>
			</Stack>
			<Stack direction="row" gap={4}>
				<AppRightSelect
					label={'Users'}
					labelId={'users'}
					actionKey={'setUsersRights'}
					styles={inputStyles}
				/>
			</Stack>
		</ModalForm>
	)
}